import React, {useState}  from "react";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { RepositoryApi } from "../app/api/repository.api";
import { useQuery } from "@tanstack/react-query";


export function RepositoryForm()
{
    const repository = RepositoryApi();

    const fetchRepository = async () => {
        const {data} = await repository.findAll();
        return data.data.owned;
    };
             
    const { data } = useQuery({
        queryKey: ["allRepositories"],
        queryFn: fetchRepository,
    });

    const [inputs, setInputs] = useState({});
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(0);
    
    const handleInputs = (event) => {

        const { name, value } = event.target;

        if (name === "name") {
          const exists = data?.some( (item) => item.name?.toLowerCase() === value?.toLowerCase() );
          setIsChecked(exists ? 1 : -1);
        }
        setInputs((prev) => ({ ...prev, [name]: value }));
    };

      
    const handleForm = async ( event ) => {
        event.preventDefault();
        setStatus(0);
        setIsLoading(true);

        try {
            const {data} = await repository.insert(inputs);
            setIsLoading(false);

            if (data.success) {
                setStatus(1);
                setInputs({}); 
            } 
            else { setStatus(-1); }
             
        } catch (err) { 
            setIsLoading(false);
            setStatus(-1); 
        }
    } 
        

    return(

        <div className="container-fluid">
            <div className="row"> 
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'panel'} />  </div>
                {/* ************************************************* */}
                <div className="col-md-12 py-5">  
                    <div className="row d-flex justify-content-center px-2">
                        <div className="col-lg-6">
                            {/* ----------------------------------------------------- */}
                            <form className="form" onSubmit={handleForm}> 
                                <div className="row">
                                    <div className="col-12 d-flex flex-column bg-light border p-4 rounded-3 mb-4">
                                        <span className="font-xl text-secondary"> Nouveau répertoire </span>
                                        <span className="text-secondary"> Veuillez fournir les informations requises dans ce formulaire </span>
                                    </div>
                                    {/* ----------------------------------------------------- */}
                                    <div className="col-12 d-flex flex-column mb-4 p-4 rounded-3 bg-white border">
                                        <div className="row">

                                            <div className="col-lg-12">
                                                <div className="">
                                                    <label htmlFor="input2" className="font-sm text-secondary"> Nom du répertoire </label>
                                                    <div className="d-flex gap-1 mb-2" >
                                                        <input type="name" name="name" className={`w-100 input border py-3 px-3 text-secondary rounded-2 ${ (isChecked === -1) ? "border-success" : ( (isChecked === 1) ? "border-danger" : null  ) }`} id="input2" onChange={handleInputs} required />
                                                        <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                    </div>
                                                    { 
                                                       isChecked === -1 && ( <label className="font-sm text-success mb-3"> <i className="bi bi-check-circle-fill me-2"></i> nom de répertoire disponible </label> )
                                                    }
                                                    { 
                                                       isChecked === 1 && ( <label className="font-sm text-danger mb-3"> <i className="bi bi-x-circle-fill me-2"></i> nom de répertoire indisponible </label> )
                                                    }     
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <label htmlFor="input3" className="font-sm text-secondary"> Cycle universitaire </label>
                                                <div className="d-flex gap-1 mb-2" >
                                                    <select className="w-100 border input py-3 px-3 text-secondary rounded-2" name="level" id="input3" onChange={handleInputs} required>
                                                        <option value=""> Choisir un cycle universitaire </option>
                                                        <option value="Licence"> Licence </option>
                                                        <option value="Master"> Master </option>
                                                        <option value="Doctorat"> Doctorat </option>
                                                        <option value="Autres"> Autres </option>
                                                    </select>
                                                    <span className="d-flex align-items-center border py-2 px-3 rounded-2 text-danger"> * </span> 
                                                </div>
                                            </div>
                                            <div className="col-lg-12 mb-3">
                                                <label htmlFor="input4" className="font-sm text-secondary"> Description (<span className="color-orange"> optionelle </span>) </label>
                                                <textarea className="w-100 border input py-3 px-3 text-secondary rounded-2" name="description" id="input4" rows="3" onChange={handleInputs} ></textarea>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="">
                                                    <div className="col-md-12 mb-3 d-flex gap-4 p-3 border-start border-end border-5 rounded bg-light">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="status" value={"structured"} id="flexRadioDefault1" required onChange={handleInputs} style={{ height:'20px', width:'20px' }} />
                                                            <label className="text-secondary font-md" htmlFor="flexRadioDefault1" title="Répertoire structuré par défaut"> Répertoire structuré par défaut </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="status" value={"default"} id="flexRadioDefault2" required onChange={handleInputs} style={{ height:'20px', width:'20px' }} />
                                                            <label className="text-secondary font-md" htmlFor="flexRadioDefault2" title="Répertoire vide par défaut"> Répertoire vide par défaut </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="px-3">
                                                <div className="d-flex flex-column alert alert-success">
                                                    <span className="mb-2 font-lg text-muted"> Note d'information </span>
                                                    <span className="text-muted font-sm"> Une fois le répertoire créé, vous aurez la possibilité de le partager avec d'autres ulisateurs, donc il est important de bien remplir ce formulaire pour une meilleur exploitation de son contenu. </span>
                                                </div>
                                            </div>
                                        </div>      
                                    </div>

                                    {/* ----------------------------------------------------- */}
                                    <div className="row">
                                    {
                                      isLoading && (
                                        <div className="col-lg-12 d-flex justify-content-center align-items-center mb-4"> 
                                          <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === 1 && (
                                        <div className="col-lg-12 mb-3">
                                          <div className="alert alert-success">
                                              Répertoire créé avec succes
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      status === -1 && (
                                        <div className="col-lg-12 mb-3">
                                          <div className="alert alert-danger">
                                             Une erreur est survenue lors de la creation du répertoire, veuillez rééssayer .
                                          </div>
                                        </div>
                                      )
                                    }
                                    </div>
                                    {/* ----------------------------------------------------- */}
                                    <div className="col-12 mb-4 d-flex p-4 border rounded"> 
                                        <button className="btn btn-green py-2 px-4" disabled={ ( isChecked === 1 || isChecked === 0 ) && true } > 
                                            Enregistrer <i className="bi bi-arrow-right ms-2"></i> 
                                        </button> 
                                    </div>
                                
                                </div>
                            </form>

                        </div>
                    </div>     
                </div> 
        
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
        
            </div>
        </div>  

    )
}
